import React, { useState } from 'react';
import cn from 'classnames';
import './GradeModal.scss';

const GRADE_LABELS = ['', 'Poor', 'Below Average', 'Average', 'Good', 'Excellent'];

const GradeModal = ({ messages, selectedThread, selectedModel, llmContext, onSave, onClose }) => {
  const [grade, setGrade] = useState(0);
  const [notes, setNotes] = useState('');
  const [isGolden, setIsGolden] = useState(false);

  const handleSave = () => {
    onSave({ humanGrade: grade || null, humanNotes: notes || null, isGoldenDataset: isGolden });
  };

  return (
    <div className='grade-modal-overlay' onClick={onClose}>
      <div className='grade-modal' onClick={e => e.stopPropagation()}>
        <div className='modal-header'>
          <h3>Grade Conversation</h3>
          <button className='close-btn' onClick={onClose}>
            ×
          </button>
        </div>

        <div className='modal-body'>
          <div className='conversation-summary'>
            <div className='summary-item'>
              <span className='label'>Shopper</span>
              <span className='value'>{selectedThread?.testShopperName || 'None'}</span>
            </div>
            <div className='summary-item'>
              <span className='label'>Messages</span>
              <span className='value'>{messages.length}</span>
            </div>
            <div className='summary-item'>
              <span className='label'>Model</span>
              <span className='value'>{selectedModel}</span>
            </div>
            <div className='summary-item'>
              <span className='label'>Tokens</span>
              <span className='value'>{llmContext?.tokenCount || 0}</span>
            </div>
          </div>

          <div className='grade-section'>
            <label>Rating</label>
            <div className='star-rating'>
              {[1, 2, 3, 4, 5].map(n => (
                <button key={n} className={cn('star', { active: n <= grade })} onClick={() => setGrade(n)}>
                  ★
                </button>
              ))}
            </div>
            {grade > 0 && <span className='grade-label'>{GRADE_LABELS[grade]}</span>}
          </div>

          <div className='notes-section'>
            <label>Notes</label>
            <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder='What worked well? What needs improvement?' rows={4} />
          </div>

          <div className='golden-section'>
            <label className='checkbox-label'>
              <input type='checkbox' checked={isGolden} onChange={e => setIsGolden(e.target.checked)} />
              <span>Save to Golden Dataset</span>
            </label>
            <p className='golden-hint'>Golden examples are used for future prompt evaluation and training.</p>
          </div>
        </div>

        <div className='modal-footer'>
          <button className='cancel-btn' onClick={onClose}>
            Cancel
          </button>
          <button className='save-btn' onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default GradeModal;
